__webpack_require__.p = "/SKKUDING_STUDY_1/8w_router/build/";